import React, { useState, useEffect } from "react";
import styles from "./QuestionPage.module.css";
import logo from "./images/unisologo.png"; // put your logo in this path
import {
  isTokenExpired,
  removeToken,
  getToken,
  decodeToken,
} from "../../utils/TokenUtils";
import { API_URL, ENDPOINTS, postData } from "../../constants/api";


import { useLocation } from "react-router-dom";
import { use } from "react";



const QuestionPage = () => {
      const [scheduleDate,setscheduleDate]=useState({});

    const location=useLocation();

    const {state}=location;
    const {student_id,class_id,semester_id,course_id,exam_type,id}=state||{}

    const [questions,setQuestions]=useState([]);

useEffect(() => {
  const getData = async () => {
    try {
      const url = `${API_URL}/${ENDPOINTS.SYS}/reportCustom/web-get-schedule`;
      const body = { id: id };
      const response = await postData(url, body);

      const courseData = response.data[0];
      console.log("schedule date from response:", courseData);

      setscheduleDate(courseData);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const getQuestion=async()=>{

    try {
      const url = `${API_URL}/${ENDPOINTS.SYS}/reportCustom/web-question`;
      const body = { 
       class_id:class_id,
       semester_id:semester_id,
       course_id:course_id,
       exam_type:exam_type

      };
      const response = await postData(url, body);

      const q = response.data;
      setQuestions(q)
      

     
    } catch (error) {
      console.error("Error fetching data:", error);
    }


  }

  if (id) {
    getData();
    getQuestion()
  }
}, []); // ✅ Only run when `id` changes

useEffect(()=>{
console.log('question:',questions);
},[questions])


   
console.log('std:',student_id,'class:',class_id,'sem:',semester_id,'course:',course_id,'exam type:',exam_type,'id:',id)
  const [timeLeft, setTimeLeft] = useState(60 * 60); // 1 hour

 

  const formatTime = (seconds) => {
    const hrs = Math.floor(seconds / 3600);
    const mins = Math.floor((seconds % 3600) / 60);
    const secs = seconds % 60;
    return `${hrs}h ${mins}m ${secs}s`;
  };

  // 🧩 Question List
 

  const [answers, setAnswers] = useState({});

  const handleAnswer = (index, value) => {
    setAnswers((prev) => ({ ...prev, [index]: value }));
  };

  useEffect(()=>{
    console.log('answers:',answers);
  },[answers])

  return (
    <div className={styles.container}>
      {/* ===== Header ===== */}
      <header className={styles.header}>
        <div className={styles.headerTop}>
          <img src={logo} alt="University Logo" className={styles.logo} />
          <h1 className={styles.university}>University of Somalia - UNISO</h1>
        </div>

        <div className={styles.headerInfo}>
          <p>
            <strong>Course:</strong> {scheduleDate?.['course']} &nbsp;|&nbsp;
            <strong>Semester:</strong> {scheduleDate?.['semester']}
          </p>
          <p>
            <strong>Duration:</strong>{scheduleDate?.start_exam?.split(" ")[1]}
- {scheduleDate?.end_Exam?.split(" ")[1] } 
            
          </p>
        </div>
      </header>

      {/* ===== Questions ===== */}
      <div className={styles.questions}>
        { 
         questions.length>0 &&
        
        questions.map((q, index) => (
          <div key={index} className={styles.questionCard}>
            <h3 className={styles.qText}>
              {index + 1}. {q.name} <span className={styles.marks}>({q.marks} marks)</span>
            </h3>

            {q.type === "tf" && (
              <div className={styles.optionGroup}>
                {["True", "False"].map((opt) => (
                  <label
                    key={opt}
                    className={`${styles.option} ${answers[index] === opt ? styles.selected : ""}`}
                  >
                    <input type="radio" name={`q${index}`} value={opt} onChange={() => handleAnswer(index, opt)} />
                    {opt}
                  </label>
                ))}
              </div>
            )}

            {q.type === "choose" && (
              <div className={styles.optionGroup}>
                {q.options.split(",").map((opt, i) => (
                  <label
                    key={i}
                    className={`${styles.option} ${answers[index] === opt ? styles.selected : ""}`}
                  >
                    <input type="radio" name={`q${index}`} value={opt} onChange={() => handleAnswer(index, opt)} />
                    {opt}
                  </label>
                ))}
              </div>
            )}

            {q.type === "direct" && (
              <textarea
                className={styles.directInput}
                placeholder="Write your answer here..."
                onChange={(e) => handleAnswer(index, e.target.value)}
              ></textarea>
            )}
          </div>
        ))}
      </div>

      <button className={styles.submitBtn}>Submit Answers</button>
    </div>
  );
};

export default QuestionPage;
